import React from 'react';
import { connect } from 'react-redux';
import { Button, Input, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField, AvFeedback } from 'availity-reactstrap-validation';

import { IRootState } from 'app/shared/reducers';
import { verifyDevice, purgeDevice, resetDevice } from './tenant.reducer';

export interface IUploadFiletUpdateProps extends StateProps, DispatchProps {}

export interface IDeviceDetails {
  name: string;
  mac: string;
  ip: string;
  count: number;
  tenant: string;
  domain: string;
  site: string;
  firmware: string;
  lastOnline: string;
  registeredDate: string;
  tokenCount: number;
}

export interface IVerifyDeviceUpdateState {
  deviceId: string;
  responseMessage: string;
  responseObject: IDeviceDetails[];
  responseModal: boolean;
  purgeModal: boolean;
  resetModal: boolean;
}

export class VerifyDevice extends React.Component<any, any> {
  state: IVerifyDeviceUpdateState = {
    deviceId: '',
    responseModal: false,
    purgeModal: false,
    resetModal: false,
    responseMessage: '',
    responseObject: []
  };

  toggleResponseModal = () => {
    this.setState(prevState => ({
      responseModal: !prevState.responseModal
    }));
  };

  togglePurgeModal = () => {
    this.setState(prevState => ({
      purgeModal: !prevState.purgeModal
    }));
  };

  toggleResetModal = () => {
    this.setState(prevState => ({
      resetModal: !prevState.resetModal
    }));
  };

  handleInvalidSubmit = (event, errors, values) => {
    this.setState({ error: true });
  };

  handleChange = e => {
    this.setState({ deviceId: e.target.value });
  };

  handleVerify = async e => {
    e.preventDefault();
    const query = this.state.deviceId;
    const response = await this.props.verifyDevice(query);
    response.value.status === 200 &&
      this.setState({
        responseObject: response.value.data,
        responseModal: true
      });
  };

  handlePurge = async e => {
    e.preventDefault();
    const query = this.state.deviceId;
    const response = await this.props.purgeDevice(query);
    this.setState({
      purgeModal: false,
      responseMessage: response.value.data ? 'Device purged' : 'Device not found',
      responseModal: true
    });
  };

  handleReset = async e => {
    e.preventDefault();
    const query = this.state.deviceId;
    const response = await this.props.resetDevice(query);
    this.setState({
      resetModal: false,
      responseMessage: response.value.data ? 'Device reset to factory' : 'Device not found',
      responseModal: true
    });
  };

  render() {
    return (
      <div>
        <Col className="btn-group flex-btn-group-container text-left">
          <Input type="text" name="deviceName" placeholder="Search for device" onChange={this.handleChange} required />
          <Button type="submit" onClick={this.handleVerify} disabled={this.state.deviceId === ''}>
            Verify
          </Button>
          <Button type="submit" color="warning" onClick={this.toggleResetModal} disabled={this.state.deviceId === ''}>
            Reset
          </Button>
          <Button type="submit" color="danger" onClick={this.togglePurgeModal} disabled={this.state.deviceId === ''}>
            Purge
          </Button>
        </Col>

        <Modal size="lg" style={{ maxWidth: '1200px' }} isOpen={this.state.responseModal} toggle={this.toggleResponseModal}>
          <ModalHeader toggle={this.toggleResponseModal}>
            {this.state.responseObject && this.state.responseObject.length > 0 ? '' : 'Device not found'}
          </ModalHeader>
          <ModalBody>
            {this.state.responseObject && this.state.responseObject.length > 0 ? (
              <Table bordered>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Mac</th>
                    <th>IP</th>
                    <th>OTA Count</th>
                    <th>Login Count</th>
                    <th>Tenant</th>
                    <th>Domain</th>
                    <th>Site</th>
                    <th>Firmware</th>
                    <th>Registered</th>
                    <th>Last Online</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseObject.map((device, index) => (
                    <tr key={index}>
                      <td>{device.name}</td>
                      <td>{device.mac}</td>
                      <td>{device.ip}</td>
                      <td>{device.count}</td>
                      <td>{device.tokenCount}</td>
                      <td>{device.tenant}</td>
                      <td>{device.domain}</td>
                      <td>{device.site}</td>
                      <td>{device.firmware}</td>
                      <td>{device.registeredDate}</td>
                      <td>{device.lastOnline}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : null}
            <Row>
              <Col className="btn-group flex-btn-group-container text-right">
                <Button color="primary" onClick={this.toggleResponseModal}>
                  Ok
                </Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>

        <Modal isOpen={this.state.purgeModal} toggle={this.togglePurgeModal}>
          <ModalHeader toggle={this.togglePurgeModal}>Are you sure you want to purge this device from the database ?</ModalHeader>
          <ModalBody>
            <Row>
              <Col className="btn-group flex-btn-group-container text-right">
                <Button color="primary" onClick={this.handlePurge}>
                  Ok
                </Button>
                <Button onClick={this.togglePurgeModal}>Cancel</Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>

        <Modal size="lg" style={{ maxWidth: '1200px' }} isOpen={this.state.resetModal} toggle={this.toggleResetModal}>
          <ModalHeader toggle={this.toggleResetModal}>Are you sure you want to Reset To Factory this device ?</ModalHeader>
          <ModalBody>
            <Row>
              <Col className="btn-group flex-btn-group-container text-right">
                <Button color="primary" onClick={this.handleReset}>
                  Ok
                </Button>
                <Button onClick={this.toggleResetModal}>Cancel</Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ tenant }: IRootState) => ({
  // deviceId: tenant.deviceId
});

const mapDispatchToProps = {
  verifyDevice,
  purgeDevice,
  resetDevice
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyDevice);
